import _sfc_main from "./CheckboxPC.vue2.mjs";
/* empty css                 */
import normalizeComponent from "../../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "tui-checkbox" }, [_c("input", { directives: [{ name: "model", rawName: "v-model", value: _setup.checked, expression: "checked" }], attrs: { "type": "checkbox", "disabled": _setup.props.disabled }, domProps: { "checked": Array.isArray(_setup.checked) ? _vm._i(_setup.checked, null) > -1 : _setup.checked }, on: { "change": [function($event) {
    var $$a = _setup.checked, $$el = $event.target, $$c = $$el.checked ? true : false;
    if (Array.isArray($$a)) {
      var $$v = null, $$i = _vm._i($$a, $$v);
      if ($$el.checked) {
        $$i < 0 && (_setup.checked = $$a.concat([$$v]));
      } else {
        $$i > -1 && (_setup.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
      }
    } else {
      _setup.checked = $$c;
    }
  }, _setup.handleValueChange] } }), _c("span", { staticClass: "tui-checkbox-slot-container", on: { "click": _setup.handleCheckBoxClick } }, [_vm._t("default")], 2)]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "57e9d7b2"
);
const CheckboxPC = __component__.exports;
export {
  CheckboxPC as default
};
